function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { initializeChagebee } from "@common/services/helpers";
import { enableWindowOnError, hexColorAlpha, initializeFirebase } from "@common/utils/helpers";
enableWindowOnError({
    product: "elemental"
});
initializeFirebase();
import "@common/styles/common.scss";
import "@styles/app.scss";
import "element-scroll-polyfill";
import "url-search-params-polyfill";
import ResizeObserver from "resize-observer-polyfill";
if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
}
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import App from "@common/containers/App";
import reducers from "@common/reducers";
import { client } from "@common/services/request";
import { PRODUCT_NAME } from "@config/constants";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import Main from "./main";
import * as styles from "@common/styles/_exports.module.scss";
import { c1, h1, paper, t1 } from "@styles";
console.log("[".concat(PRODUCT_NAME, "] ").concat(process.env.APP_VERSION, ".").concat(process.env.LAST_COMMIT_SHA));
var composeEnhancers = compose;
var middleware = [
    thunk
];
// if (process.env.NODE_ENV === 'development') {
//   const logger = require('redux-logger');
composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeEnhancers;
//   middleware = [...middleware, logger];
// }
export var store = createStore(reducers, composeEnhancers(applyMiddleware.apply(void 0, _to_consumable_array(middleware))));
// Enable the client to be able to dispatch actions
// on specific responses/errors.
// TODO: update 'c1' theme color based on the brand colors
client.__dispatch = store.dispatch;
var theme = createTheme({
    palette: {
        primary: {
            main: "".concat(c1, " !important")
        }
    },
    typography: {
        // useNextVariants: true,
        fontFamily: styles["font-weight-medium"],
        allVariants: {
            color: t1 || "black"
        }
    },
    overrides: {
        MuiInput: {
            underline: {
                "&:hover:not($disabled):before": {
                    borderBottom: "1px solid ".concat(h1 || "rgba(0, 0, 0, 0.42)", " !important")
                }
            }
        },
        MuiRadio: {
            root: {
                color: "".concat(t1 || "rgba(0, 0, 0, 0.42)", " !important"),
                "&$checked": {
                    color: "".concat(t1 || c1, " !important")
                }
            }
        },
        MuiCheckbox: {
            root: {
                color: "".concat(t1 || "rgba(0, 0, 0, 0.42)", " !important"),
                "&$checked": {
                    color: "".concat(t1 || c1, " !important")
                },
                "&:hover": {
                    backgroundColor: "".concat(hexColorAlpha(c1, 0.04), " !important")
                }
            }
        },
        MuiChip: {
            outlined: {
                backgroundColor: "transparent !important"
            }
        },
        MuiPaper: paper ? {
            root: {
                backgroundColor: "".concat(paper, " !important"),
                color: t1 ? "".concat(t1, " !important") : ""
            }
        } : undefined
    }
});
initializeChagebee();
var template = /*#__PURE__*/ _jsx(Provider, {
    store: store,
    children: /*#__PURE__*/ _jsx(Router, {
        children: /*#__PURE__*/ _jsx(MuiThemeProvider, {
            theme: theme,
            children: /*#__PURE__*/ _jsx(Main, {
                children: /*#__PURE__*/ _jsx(App, {})
            })
        })
    })
});
render(template, document.getElementById("root"));
